export default "__VITE_ASSET__CygBppW___"